export default __webpack_public_path__ + "static/media/frame-2.bdd91d47.png";